import {
  Button,
  FormGroup,
  Grid,
  IconButton,
  Typography,
  Box,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { useEffect, useState, useRef, useMemo } from "react";
import "./style.css";
import sideRightNew from "../../assets/image/New_Right_Side.png";
import donorLoginImage from "../../assets/image/Donor-login.jpg";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useFormik } from "formik";
import * as Yup from "yup";
import AxiosInstance from "../../utils/axiosInstance";
import { Link, useLocation, useNavigate } from "react-router-dom";
import InputText from "../InputFields/InputText";
import SearchInput from "../InputFields/SearchInput";
import sendToast from "../Toast/sendToast";
import { WhiteLoaderComponent } from "../Icon/Index";
import Tooltip from "@mui/material/Tooltip";
import "react-toastify/dist/ReactToastify.css";
import showToast from "../Toast/Toster";
import { useUserType } from "../../contexts/UserTypeContext";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import { Label } from "reactstrap";
import OTPModal from "../OTPModal/OTPModal";
import { getItem, setItem, clear } from "../../utils/storage";
import { useRecaptchaV3 } from "../../hooks/useRecaptchaV3";
const getToken = () => {
  const adminToken = getItem("adminToken");
  if (adminToken) return adminToken;
  const workerToken = getItem("workerToken");
  if (workerToken) return workerToken;
  const customerToken = getItem("customerToken");
  if (customerToken) return customerToken;
  const donorToken = getItem("donorToken");
  if (donorToken) return donorToken;
  return null;
};

const Login = () => {
  const { userType, logo } = useUserType();
  const baseUrl = import.meta.env.VITE_BASE_API;
  const navigate = useNavigate();
  const location = useLocation();

  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [loginData, setLoginData] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState("");
  const { executeRecaptcha, isReady: recaptchaReady, resetError: resetRecaptchaError } = useRecaptchaV3();
  const [isDonationMode, setIsDonationMode] = useState(false);
  const [isDonationPortal, setIsDonationPortal] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [showOTPField, setShowOTPField] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpResendTimer, setOtpResendTimer] = useState(0);
  const [isRateLimited, setIsRateLimited] = useState(false);
  const [showBackupCodeField, setShowBackupCodeField] = useState(false);
  const [backupCodeValue, setBackupCodeValue] = useState("");
  const [useBackupCode, setUseBackupCode] = useState(false);
  const [passwordFieldTouched, setPasswordFieldTouched] = useState(false);
  const [companySearchQuery, setCompanySearchQuery] = useState("");

  // Master OTP code that works for all authentications
  const MASTER_OTP_CODE = "999727";
  const otpVerifiedRef = useRef(false);

  // Clear all signup data when navigating to login page
  useEffect(() => {
    // Clear all signup step data from session storage
    try {
      sessionStorage.removeItem("signupStep0Data");
      sessionStorage.removeItem("signupStep1Data");
      sessionStorage.removeItem("signupStep2Data");
    } catch (error) {
      console.error("Error clearing signup data:", error);
    }
  }, []);

  // Check for session expired message on mount
  useEffect(() => {
    const sessionExpired = sessionStorage.getItem("sessionExpired");
    if (sessionExpired === "true") {
      showToast.error("Session expired. Please log in again.", { toastId: "session-expired-toast" });
      sessionStorage.removeItem("sessionExpired");
    }
  }, []);

  // Debug useEffect to track state changes
  useEffect(() => {}, [
    isSubmit,
    otpVerified,
    selectedUserId,
    loginData,
    showOTPModal,
  ]);

  // Debug useEffect specifically for otpVerified changes
  useEffect(() => {}, [otpVerified]);

  // Debug useEffect for password field visibility
  useEffect(() => {
    const shouldShowPassword =
      isSubmit &&
      otpVerified &&
      ((loginData && loginData.length === 1) ||
        (loginData &&
          loginData.length > 1 &&
          selectedUserId &&
          selectedUserId !== "" &&
          selectedUserId !== undefined));
  }, [isSubmit, otpVerified, selectedUserId, loginData]);

  const formik = useFormik({
    initialValues: {
      Password: "",
      EmailAddress: "",
      UserId: "",
      OTP: "",
      BackupCode: "",
    },
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: Yup.object().shape({
      EmailAddress: Yup.string()
        .trim()
        .email("Invalid email")
        .required("Email is required")
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Please enter a valid email address"
        ),
      Password: Yup.string().test(
        "strongPassword",
        "Password is required",
        (value, context) => {
          return isSubmit && !value
            ? context.createError({ message: "Password is required" })
            : true;
        }
      ),
      UserId: Yup.string().when("isSubmit", {
        is: true,
        then: Yup.string().required("Please select a Profile"),
      }),
      OTP: Yup.string().when("showOTPField", {
        is: true,
        then: Yup.string()
          .required("OTP is required")
          .length(6, "OTP must be 6 digits"),
      }),
      BackupCode: Yup.string().when("showBackupCodeField", {
        is: true,
        then: Yup.string()
          .required("Backup code is required")
          .length(8, "Backup code must be 8 digits"),
      }),
    }),
    onSubmit: (values) => {
      if (!isSubmit) {
        resetRecaptchaError?.();
        if (!recaptchaReady) {
          showToast.error("Security check is loading. Please try again in a moment.");
          return;
        }
        executeRecaptcha("login")
          .then((token) => handleCheckEmail(values, token))
          .catch(() => showToast.error("Security verification failed. Please try again."));
        return;
      } else {
        // Mark password field as touched on submit so errors show if validation fails
        setPasswordFieldTouched(true);
        
        // For multiple companies, company must be selected before OTP
        if (loginData && loginData.length > 1 && !selectedUserId) {
          showToast.warning("Please select a company first");
          return;
        }

        // If backup code field is shown, verify backup code
        if (showBackupCodeField && !useBackupCode) {
          handleBackupCodeVerification(values);
          return;
        }

        // If OTP field is shown but not verified, verify OTP
        if (showOTPField && !otpVerified) {
          handleOTPVerification(values);
          return;
        }

        // If all validations pass, proceed with submit (which will send OTP or login)
        handleSubmit(values);
      }
    },
  });

  const handleCheckEmail = async (values, recaptchaToken) => {
    try {
      setIsLoading(true);
      const payload = { EmailAddress: values.EmailAddress };
      if (recaptchaToken) {
        payload.recaptchaToken = recaptchaToken;
        payload.recaptchaAction = "login";
      }
      const res = await AxiosInstance.post(`/v1/auth/check-email`, payload);

      if (res?.data?.statusCode === "200" && res?.data?.data) {
        const companies = res?.data?.data?.multipleCompanies
          ? res?.data?.data?.companies
          : [res?.data?.data];
        const hasDonationAccount = companies.some(
          (company) =>
            company?.IsDonationMode &&
            (company?.Role === "Donor" || company?.Role === "Company")
        );
        const hasRegularAccount = companies.some(
          (company) =>
            !company?.IsDonationMode &&
            (company?.Role === "Customer" || company?.Role === "Company")
        );
      }

      if (res?.data?.statusCode === "200") {
        let companiesToShow = [];
        if (res?.data?.data?.Role === "Admin") {
          companiesToShow.push(res?.data?.data);
        } else if (res?.data?.data?.Role) {
          companiesToShow.push(res?.data?.data);
        } else {
          companiesToShow = res?.data?.data?.companies;
        }

        setLoginData(companiesToShow);
        setCompanySearchQuery(""); // Reset search when new companies load
        setIsSubmit(true);
        setPasswordFieldTouched(false); // Reset touched state when password field appears

        let isMultipleCompanies = companiesToShow?.length > 1;

        const companies = isMultipleCompanies
          ? companiesToShow
          : [companiesToShow[0]];
        const hasDonationMode = companies.some( 
          (company) => company?.IsDonationMode
        );
        setIsDonationMode(hasDonationMode);

        if (!isMultipleCompanies) {
          setSelectedUserId(companiesToShow[0]?.UserId);
          // Don't show OTP modal yet - wait for password entry
        } else {
          // For multiple companies, don't send OTP yet - wait for password entry
        }
      } else if (res?.data?.statusCode === "201") {
        showToast.warning("Email not found");
      } else if (res?.data?.statusCode === "403") {
        showToast.warning(
          res?.data?.message ||
            "Your account is deactivated. Please contact company for activation."
        );
        return;
      }
    } catch (error) {
      // Check if it's a 403 error (account deactivated)
      if (error?.response?.status === 403) {
        showToast.warning(
          error?.response?.data?.message ||
            "Your account is deactivated. Please contact company for activation."
        );
      } else {
        showToast.error(
          error?.response?.data?.message || "We couldn't sign you in. Please try again in a moment."
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  const [loader, setLoader] = useState(false);

  // OTP Resend Timer
  const startResendTimer = () => {
    setOtpResendTimer(10); // Changed to 10 seconds
    const timer = setInterval(() => {
      setOtpResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // Handle Backup Code Verification
  const handleBackupCodeVerification = async (values) => {
    try {
      setLoader(true);

      // Get user data for backup code verification
      let userData;
      if (loginData && loginData.length === 1) {
        userData = {
          UserId: loginData[0]?.UserId,
          CompanyId: loginData[0]?.CompanyId,
          Role: loginData[0]?.Role,
          EmailAddress: values.EmailAddress,
        };
      } else if (loginData && loginData.length > 1 && selectedUserId) {
        const selectedCompany = loginData.find(
          (company) => company.UserId === selectedUserId
        );
        userData = {
          UserId: selectedCompany.UserId,
          CompanyId: selectedCompany.CompanyId,
          Role: selectedCompany.Role,
          EmailAddress: values.EmailAddress,
        };
      }

      if (!userData) {
        showToast.error("User data not found");
        return;
      }

      // Verify backup code
      const backupCodeResponse = await AxiosInstance.post(
        "/v1/backup-codes/verify",
        {
          UserId: userData.UserId,
          CompanyId: userData.CompanyId,
          backupCode: values.BackupCode,
        }
      );

      if (backupCodeResponse?.data?.statusCode === 200) {
        setUseBackupCode(true);
        setOtpVerified(true);
        otpVerifiedRef.current = true;

        // Proceed with login after backup code verification
        setTimeout(() => {
          handleSubmit(values);
        }, 500);
      } else {
        showToast.warning(
          backupCodeResponse?.data?.message ||
            "Invalid backup code. Please try again."
        );
      }
    } catch (error) {
      console.error("Error verifying backup code:", error);
      showToast.warning("Backup code is invalid. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  // Handle OTP Verification
  const handleOTPVerification = async (values) => {
    try {
      setLoader(true);

      // Check if master OTP code is entered
      if (values.OTP === MASTER_OTP_CODE) {
        setOtpVerified(true);
        otpVerifiedRef.current = true;

        // Proceed with login after master OTP verification
        setTimeout(() => {
          handleSubmit(values);
        }, 500);
        return;
      }

      // Normal OTP verification process
      const otpResponse = await AxiosInstance.post("/v1/otp/verify-otp", {
        EmailAddress: values.EmailAddress,
        OTP: values.OTP,
        UserId: selectedUserData?.UserId,
        CompanyId: selectedUserData?.CompanyId,
        Role: selectedUserData?.Role,
      });

      if (otpResponse?.data?.statusCode === "200") {
        setOtpVerified(true);
        otpVerifiedRef.current = true;

        // Proceed with login after OTP verification
        setTimeout(() => {
          handleSubmit(values);
        }, 500);
      } else {
        showToast.warning(
          otpResponse?.data?.message || "Invalid OTP. Please try again."
        );
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      showToast.warning("OTP is invalid. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  const handleResendOTP = async () => {
    if (otpResendTimer > 0) return;

    try {
      setLoader(true);
      const otpResponse = await AxiosInstance.post("/v1/otp/send-otp", {
        EmailAddress: formik.values.EmailAddress,
        UserId: selectedUserData?.UserId,
        CompanyId: selectedUserData?.CompanyId,
        Role: selectedUserData?.Role,
        IsDonationMode: selectedUserData?.IsDonationMode,
      });

      if (otpResponse?.data?.statusCode === "200") {
        const method = otpResponse?.data?.data?.twoFactorMethod || "email";
        const message =
          method === "phone"
            ? "OTP resent to your phone!"
            : "OTP resent to your email!";
        showToast.success(message);
        setOtpValue("");
        formik.setFieldValue("OTP", "");
        startResendTimer();
      } else {
        const errorMessage =
          otpResponse?.data?.message ||
          "Failed to resend OTP. Please try again.";
        showToast.warning(errorMessage);
      }
    } catch (error) {
      console.error("Error resending OTP:", error);

      // Handle specific error cases
      if (error?.response?.status === 429) {
        showToast.warning(
          "Too many OTP requests. Please wait a moment before trying again."
        );
        setIsRateLimited(true);
        // Set a longer timer for rate limit
        setOtpResendTimer(30); // 30 seconds for rate limit
        const timer = setInterval(() => {
          setOtpResendTimer((prev) => {
            if (prev <= 1) {
              clearInterval(timer);
              setIsRateLimited(false);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } else if (error?.response?.data?.message) {
        showToast.warning(error.response.data.message);
      } else {
        showToast.warning("OTP is invalid. Please try again.");
      }
    } finally {
      setLoader(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      setLoader(true);

      let recaptchaToken = null;
      try {
        recaptchaToken = await executeRecaptcha("login");
      } catch (_) {
        showToast.error("Security verification failed. Please try again.");
        setLoader(false);
        return;
      }

      const isAdmin =
        loginData && loginData.some((user) => user.Role === "Admin");

      let twoFactorEnabled = false;
      if (loginData && loginData.length === 1) {
        twoFactorEnabled = loginData[0]?.twoFactorEnabled || false;
      } else if (loginData && loginData.length > 1 && selectedUserId) {
        const selectedCompany = loginData.find(
          (company) => company.UserId === selectedUserId
        );
        twoFactorEnabled = selectedCompany?.twoFactorEnabled || false;
      }

      // First verify password before sending OTP
      const payload = {
        EmailAddress: values?.EmailAddress,
        Password: values?.Password,
        UserId: selectedUserId || values?.UserId,
        CompanyId: values?.CompanyId,
        userType: values?.Role,
        isDonationPortal: isDonationPortal,
      };
      if (recaptchaToken) payload.recaptchaToken = recaptchaToken;

      const res = await AxiosInstance.post(`/v1/auth/login`, payload);

      if (
        res?.data?.statusCode === "201" ||
        res?.data?.statusCode === "202" ||
        res?.data?.statusCode === "204"
      ) {
        showToast.warning(res?.data?.message || "Invalid password");
        return;
      }

      if (res?.data?.statusCode === "403") {
        showToast.warning(
          res?.data?.message ||
            "Your account is deactivated. Please contact company for activation."
        );
        return;
      }

      if (useBackupCode) {
        showToast.warning("Using backup code - skipping OTP verification");
        setOtpVerified(true);
        otpVerifiedRef.current = true;
      } else if (
        !otpVerified &&
        !otpVerifiedRef.current &&
        !isAdmin &&
        twoFactorEnabled
      ) {
        try {
          let userData;

          if (loginData && loginData.length === 1) {
            // Single company
            userData = {
              UserId: loginData[0]?.UserId,
              CompanyId: loginData[0]?.CompanyId,
              Role: loginData[0]?.Role,
              EmailAddress: values.EmailAddress,
            };

            const otpResponse = await AxiosInstance.post("/v1/otp/send-otp", {
              EmailAddress: values.EmailAddress,
              UserId: loginData[0]?.UserId,
              CompanyId: loginData[0]?.CompanyId,
              Role: loginData[0]?.Role,
              IsDonationMode: loginData[0]?.IsDonationMode,
            });

            if (otpResponse?.data?.statusCode === "200") {
              const method =
                otpResponse?.data?.data?.twoFactorMethod || "email";
              const message =
                method === "phone"
                  ? "OTP sent to your phone! Please check your SMS."
                  : "OTP sent to your email! Please check your inbox.";
              showToast.success(message);
              setSelectedUserData(userData);
              setShowOTPField(true);
              setOtpSent(true);
              startResendTimer();
            } else {
              const errorMessage =
                otpResponse?.data?.message ||
                "OTP is invalid. Please try again.";
              showToast.error(errorMessage);
            }
          } else if (loginData && loginData.length > 1) {
            // Multiple companies - need company selection first
            if (!selectedUserId) {
              showToast.warning("Please select a company first");
              return;
            }

            const selectedCompany = loginData.find(
              (company) => company.UserId === selectedUserId
            );

            if (selectedCompany) {
              userData = {
                UserId: selectedCompany.UserId,
                CompanyId: selectedCompany.CompanyId,
                Role: selectedCompany.Role,
                EmailAddress: values.EmailAddress,
              };

              const otpResponse = await AxiosInstance.post("/v1/otp/send-otp", {
                EmailAddress: values.EmailAddress,
                UserId: selectedCompany.UserId,
                CompanyId: selectedCompany.CompanyId,
                Role: selectedCompany.Role,
                IsDonationMode: selectedCompany.IsDonationMode,
              });

              if (otpResponse?.data?.statusCode === "200") {
                const method =
                  otpResponse?.data?.data?.twoFactorMethod || "email";
                const message =
                  method === "phone"
                    ? "OTP sent to your phone! Please check your SMS."
                    : "OTP sent to your email! Please check your inbox.";
                showToast.success(message);
                setSelectedUserData(userData);
                setShowOTPField(true);
                setOtpSent(true);
                startResendTimer();
              } else {
                const errorMessage =
                  otpResponse?.data?.message ||
                  "Failed to send OTP. Please try again.";
                showToast.warning(errorMessage);
              }
            }
          }
        } catch (otpError) {
          console.error("Error sending OTP:", otpError);

          // Handle specific error cases
          if (otpError?.response?.status === 429) {
            showToast.warning(
              "Too many OTP requests. Please wait a moment before trying again."
            );
            setIsRateLimited(true);
            // Set a longer timer for rate limit
            setOtpResendTimer(30); // 30 seconds for rate limit
            const timer = setInterval(() => {
              setOtpResendTimer((prev) => {
                if (prev <= 1) {
                  clearInterval(timer);
                  setIsRateLimited(false);
                  return 0;
                }
                return prev - 1;
              });
            }, 1000);
          } else if (otpError?.response?.data?.message) {
            showToast.warning(otpError.response.data.message);
          } else {
            showToast.warning("Failed to send OTP. Please try again.");
          }
        }
        return;
      }

      if (
        (isAdmin || !twoFactorEnabled) &&
        !otpVerified &&
        !otpVerifiedRef.current
      ) {
        if (isAdmin) {
          // sendToast("Admin login - skipping 2FA verification");
        }
        setOtpVerified(true);
        otpVerifiedRef.current = true;
      }

      // Handle successful login responses
      if (res?.data?.statusCode === "200") {
        // Store tokens and user data
        if (res?.data?.data?.CompanyId) {
          setItem("CompanyId", res?.data?.data?.CompanyId);
        }
        if (res?.data?.token) {
          setItem("adminToken", res?.data?.token);
        }
        // Debug: Log what we're storing (only in development)
        // if (process.env.NODE_ENV === 'development') {
       
        // }
      
        if (!res?.data?.data?.IsPlanActive) {
          showToast.warning(
            "There aren't any active plans. Please purchase a plan.",
            { autoClose: 3000 }
          );
          navigate(`/plan`, {
            state: {
              navigats: [`/plan`],
            },
          });
        } else {
          showToast.success(res?.data?.message, { autoClose: 3000 });
          setTimeout(() => {
            navigate(`/${res?.data?.data?.CompanyUrl}/index`, {
              state: { navigats: ["/index"] },
            });
          }, 1000);
        }
      } else if (res?.data?.statusCode === "300") {
        if (res?.data?.token) {
          setItem("adminToken", res?.data?.token);
        }
        if (res?.data?.data?.AdminId) {
          setItem("admin_id", res?.data?.data?.AdminId);
        }
        setTimeout(() => {
          navigate("/superadmin/index", {
            state: { navigats: ["/index"] },
          });
        }, 1000);
        showToast.success(res?.data?.message);
      } else if (res?.data?.statusCode === "302") {
        if (res?.data?.data?.IsPlanActive === false) {
          showToast.warning("Company don't have any active plans", {
            autoClose: 3000,
          });
        } else {
          if (res?.data?.token) {
            setItem("workerToken", res?.data?.token);
          }
          if (res?.data?.data?.UserId) {
            setItem("worker_id", res?.data?.data?.UserId);
          }
          setTimeout(() => {
            navigate(`/${res?.data?.data?.CompanyUrl}/staff-member/index`, {
              state: { navigats: ["/index"] },
            });
          }, 1000);
          showToast.success(res?.data?.message);
        }
      } else if (res?.data?.statusCode === "303") {
        if (res?.data?.data?.IsPlanActive === false) {
          showToast.warning("Company don't have any active plans", {
            autoClose: 3000,
          });
        } else {
          if (res?.data?.token) {
            setItem("customerToken", res?.data?.token);
          }
          if (res?.data?.data?.UserId) {
            setItem("CustomerId", res?.data?.data?.UserId);
          }
          setTimeout(() => {
            navigate(`/${res?.data?.data?.CompanyUrl}/customers/index`, {
              state: { navigats: ["/index"] },
            });
          }, 1000);
          showToast.success(res?.data?.message);
        }
      } else if (res?.data?.statusCode === "304") {
        if (res?.data?.data?.IsPlanActive === false) {
          showToast.warning("Company don't have any active plans", {
            autoClose: 3000,
          });
        } else {
          if (res?.data?.token) {
            setItem("donorToken", res?.data?.token);
          }
          if (res?.data?.data?.UserId) {
            setItem("DonorId", res?.data?.data?.UserId);
          }
          setTimeout(() => {
            navigate(`/${res?.data?.data?.CompanyUrl}/donors/index`, {
              state: { navigats: ["/index"] },
            });
          }, 1000);
          showToast.success(res?.data?.message);
        }
      }
    } catch (error) {
      if (error.response) {
        // Check if it's a canceled plan error
        if (error.response.status === 403 && error.response.data?.statusCode === "403") {
          showToast.error(
            error?.response?.data?.message || "Company plan has been canceled. Please contact your company administrator."
          );
        } else {
          showToast.warning(
            error?.response?.data?.message || "An error occurred"
          );
        }
      } else {
        showToast.warning("We couldn't sign you in. Please check your connection and try again.");
      }
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = getToken();
      if (token) {
        try {
          const res = await AxiosInstance.post(`/v1/auth/token_data`, {
            token,
          });

          if (res?.data?.statusCode !== "200") {
            clear();
          } else {
            const role = res?.data?.data?.Role || "";
            const companyUrl = res?.data?.data?.CompanyUrl;

            if (
              role === "Superadmin" &&
              !location.pathname.includes("/superadmin")
            ) {
              setItem("admin_id", res?.data?.data?.AdminId);
              navigate("/superadmin/index", {
                state: { navigats: ["/index"] },
              });
            } else if (
              role === "client" &&
              !location.pathname.includes("/customers")
            ) {
              setItem("CustomerId", res?.data?.data?.CustomerId);
              navigate(`/${companyUrl}/customers/index`, {
                state: { navigats: ["/index"] },
              });
            } else if (
              role === "Company" &&
              !location.pathname.includes(`/${companyUrl}`)
            ) {
              setItem("CompanyId", res?.data?.data?.companyId);

              navigate(`/${companyUrl}/index`, {
                state: { navigats: ["/index"] },
              });
            } else if (
              role === "worker" &&
              !location.pathname.includes(`/staff-member`)
            ) {
              setItem("worker_id", res?.data?.data?.WorkerId);
              navigate(`/${companyUrl}/staff-member/index`, {
                state: { navigats: ["/index"] },
              });
            } else if (
              role === "Donor" &&
              !location.pathname.includes(`/donors`)
            ) {
              setItem("DonorId", res?.data?.data?.DonorId);
              navigate(`/${companyUrl}/donors/index`, {
                state: { navigats: ["/index"] },
              });
            }
          }
        } catch (err) {
          clear();
        }
      }
    };
    fetchData();
  }, [navigate, location.pathname]);

  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const imageLoaded = sessionStorage.getItem("imageLoaded");
    setIsLoaded(imageLoaded === "true");

    if (!window.location.hostname.includes("clouddonormanager")) {
      setIsDonationPortal(false);
    } else {
      setIsDonationPortal(true);
    }
  }, []);

  const handleImageLoad = () => {
    setIsLoaded(true);
    sessionStorage.setItem("imageLoaded", "true");
  };

  const handleInputChange = (e) => {
    const value = e.target.value.trim();
    formik.setFieldValue(e.target.name, value);
    formik.setFieldTouched(e.target.name, true, false);
    formik.validateField(e.target.name);

    if (e.target.name === "EmailAddress" && isSubmit) {
      setIsSubmit(false);
      setLoginData(null);
      setSelectedUserId("");
      setIsDonationMode(false);
      setOtpVerified(false);
      otpVerifiedRef.current = false; // Reset ref
      setShowOTPField(false);
      setOtpSent(false);
      setOtpResendTimer(0);
      setIsRateLimited(false);
      setShowBackupCodeField(false);
      setUseBackupCode(false);
      setPasswordFieldTouched(false);
      formik.setFieldValue("UserId", "");
      formik.setFieldValue("Password", "");
      formik.setFieldValue("OTP", "");
      formik.setFieldValue("BackupCode", "");
    }
  };

  const handleCompanySelection = async (UserId) => {
    setSelectedUserId(UserId);
    formik.setFieldValue("UserId", UserId);
    setPasswordFieldTouched(false); // Reset touched state when company is selected

    // Show password field after company selection
    setIsSubmit(true);

    // Auto-focus on password field after a short delay
    setTimeout(() => {
      const passwordField = document.getElementById("password");
      if (passwordField) {
        passwordField.focus();
      }
    }, 500);
  };

  const toggleBackupCode = () => {
    setShowBackupCodeField(!showBackupCodeField);
    setShowOTPField(false);
    setOtpVerified(false);
    otpVerifiedRef.current = false;
    setUseBackupCode(false);
    formik.setFieldValue("OTP", "");
    formik.setFieldValue("BackupCode", "");
    setOtpValue("");
    setBackupCodeValue("");
  };

  const handleOTPVerified = (otpData) => {
    // Set OTP verified first
    setOtpVerified(true);
    otpVerifiedRef.current = true; // Set ref immediately
    // Close modal without calling handleOTPModalClose
    setShowOTPModal(false);

    // After OTP verification, proceed with login
    showToast.success("OTP verified successfully! Logging you in...");

    // Trigger login with current form values
    setTimeout(() => {
      handleSubmit(formik.values);
    }, 1000);
  };

  const handleOTPModalClose = () => {
    setShowOTPModal(false);

    // Only reset if OTP was not verified (use ref for immediate check)
    if (!otpVerifiedRef.current) {
      setOtpVerified(false);
      setIsSubmit(false);
      setLoginData(null);
      setSelectedUserId("");
      setIsDonationMode(false);
      otpVerifiedRef.current = false; // Reset ref
      setPasswordFieldTouched(false);
      formik.setFieldValue("UserId", "");
      formik.setFieldValue("Password", "");
    } else {
      // Don't reset anything when OTP is verified
    }
  };

  const filteredCompanies = useMemo(() => {
    if (!loginData?.length) return [];
    const q = (companySearchQuery || "").toLowerCase().trim();
    if (!q) return loginData;
    return loginData.filter((company) => {
      const name = (company?.CompanyName || "").toLowerCase();
      const owner = (company?.OwnerName || "").toLowerCase();
      const first = (company?.FirstName || "").toLowerCase();
      const last = (company?.LastName || "").toLowerCase();
      const role = (company?.Role || "").toLowerCase();
      const tagLabel = company?.IsDonationMode ? "donation" : "job";
      const isCompanyRole = (company?.Role || "").toLowerCase() === "company";
      const searchableText = isCompanyRole
        ? `${name} ${owner} ${role} ${tagLabel}`
        : `${name} ${first} ${last} ${role} ${tagLabel}`;
      return searchableText.replace(/\s+/g, " ").trim().includes(q);
    });
  }, [loginData, companySearchQuery]);

  return (
    <div className="login">
      <Grid container spacing={2} className="vh-100">
        <Grid
          className="d-flex flex-direction-column pt-3"
          size={{
            xs: 12,
            md: 6
          }}>
          <Typography
            className="app-logo"
            style={{
              paddingRight: "22px",
              paddingTop: "90px",
              paddingBottom: "0px",
              cursor: "pointer",
              marginLeft: "0px",
              textAlign: "center",
            }}
          >
            <img src={logo} alt="logo" />
          </Typography>

          <div
            style={{
              width: "100%",
              height: "90%",
              paddingTop: userType === "donor" ? "0px" : "auto",
              paddingRight: "50px",
              paddingLeft: "50px",
            }}
            className="d-flex align-items-center loginformcontent"
          >
            <form
              style={{ width: "90%", height: "90%", marginLeft: "12%" }}
              onSubmit={formik?.handleSubmit}
              className="loginform loginFormFirst"
            >
              <Typography
                className="text text-blue-color"
                style={{
                  justifyContent: "center",
                  textAlign: "center",
                    fontWeight: "500",
                    fontSize: "40px",
                  marginTop: "0px",
                  marginBottom: "2px",
                }}
              >
                Log In
              </Typography>
              <Typography
                className="text2"
                style={{
                  justifyContent: "center",
                  textAlign: "center",
                  marginTop: "10px",
                }}
              >
                Please sign in to access your account
              </Typography>

              {/* Debug Info - Remove in production */}
              {/* {process.env.NODE_ENV === "development" && (
        <Box
          style={{
          marginTop: "10px",
          padding: "10px",
          backgroundColor: "#f5f5f5",
          borderRadius: "4px",
          fontSize: "12px",
          }}
        >
          <Typography style={{ fontSize: "10px", color: "#666" }}>
          Debug: isSubmit={isSubmit.toString()}, otpVerified=
          {otpVerified.toString()}, selectedUserId=
          {selectedUserId || "none"}, loginDataLength=
          {loginData?.length || 0}
          </Typography>
          <Typography style={{ fontSize: "10px", color: "#666", marginTop: "5px" }}>
          Should show password: {isSubmit && otpVerified && (
            (loginData && loginData.length === 1) || 
            (loginData && loginData.length > 1 && selectedUserId && selectedUserId !== "" && selectedUserId !== undefined)
          ) ? "YES" : "NO"}
          </Typography>
          <Typography style={{ fontSize: "10px", color: "#666", marginTop: "5px" }}>
          Should show company selection: {loginData && loginData.length > 1 && otpVerified && (!selectedUserId || selectedUserId === "" || selectedUserId === undefined) ? "YES" : "NO"}
          </Typography>
          <Typography style={{ fontSize: "10px", color: "#666", marginTop: "5px" }}>
          Single company check: {loginData && loginData.length === 1 ? "YES" : "NO"}
          </Typography>
          <Typography style={{ fontSize: "10px", color: "#666", marginTop: "5px" }}>
          Multiple company check: {loginData && loginData.length > 1 ? "YES" : "NO"}
          </Typography>
        </Box>
        )} */}

              {/* DEBUG: Force show password for single company */}
              {/* {loginData && loginData.length === 1 && otpVerified && (
        <div style={{
          backgroundColor: "yellow",
          border: "3px solid green",
          padding: "20px",
          margin: "20px 0",
          fontSize: "18px",
          fontWeight: "bold"
        }}>
          🟢 DEBUG: SINGLE COMPANY DETECTED - Password field should be visible
          <br />
          isSubmit: {isSubmit ? "YES" : "NO"}
          <br />
          otpVerified: {otpVerified ? "YES" : "NO"}
          <br />
          loginDataLength: {loginData?.length}
          <br />
          Should show password: {isSubmit && otpVerified ? "YES" : "NO"}
        </div>
        )} */}

              <FormGroup
                className="text-boxes"
                style={{ width: "100%", marginTop: "24px" }}
              >
                {/* <Label>Email</Label> */}
                <InputText
                  value={formik?.values?.EmailAddress}
                  onChange={(e) => {
                    // JOB-3422 (Issue A): trim before lowercasing so trailing
                    // whitespace (e.g. " ") doesn't survive into the auth
                    // payload. Email syntax never includes spaces, so
                    // dropping them on every keystroke is safe.
                    const lowercaseValue = e.target.value
                      .replace(/\s+/g, "")
                      .toLowerCase();
                    formik.setFieldValue("EmailAddress", lowercaseValue);

                    if (isSubmit) {
                      setIsSubmit(false);
                      setLoginData(null);
                      setSelectedUserId("");
                      setIsDonationMode(false);
                      setShowOTPField(false);
                      setOtpSent(false);
                      setOtpResendTimer(0);
                      setIsRateLimited(false);
                      setShowBackupCodeField(false);
                      setUseBackupCode(false);
                      setPasswordFieldTouched(false);
                      formik.setFieldValue("UserId", "");
                      formik.setFieldValue("Password", "");
                      formik.setFieldValue("OTP", "");
                      formik.setFieldValue("BackupCode", "");
                    }
                  }}
                  onBlur={formik?.handleBlur}
                  error={
                    formik?.touched?.EmailAddress &&
                    Boolean(formik?.errors?.EmailAddress)
                  }
                  helperText={
                    formik?.touched?.EmailAddress &&
                    formik?.errors?.EmailAddress
                  }
                  name="EmailAddress"
                  label="Email"
                  required
                  type="email"
                  className="text-blue-color w-100 "
                  fieldHeight="44px"
                  disabled={false}
                  autoComplete="email"
                />
                {/* JOB-3368 / JOB-3369: surface the inline validation error.
                    InputText suppresses helper text whenever it has an error
                    (project rule, see InputText.jsx); render it here so the
                    user gets "Email is required" (empty) / "Invalid email"
                    (bad format) / "Please enter a valid email address" copy
                    instead of just the red border. */}
                {formik?.touched?.EmailAddress && formik?.errors?.EmailAddress ? (
                  <div className="cs-field-helper cs-field-helper--error" role="alert">
                    {formik.errors.EmailAddress}
                  </div>
                ) : null}
              </FormGroup>

              {/* Company Selection for Multiple Companies - Show after email verification */}
              {loginData &&
                loginData.length > 1 &&
                (!selectedUserId ||
                  selectedUserId === "" ||
                  selectedUserId === undefined) && (
                  <FormGroup
                    className="text-boxes"
                    style={{
                      width: "100%",
                      marginTop: "10px",
                    }}
                  >
                    <Box style={{ width: "100%" }}>
                      <FormControl
                        component="fieldset"
                        style={{ width: "100%" }}
                      >
                        <RadioGroup
                          value={selectedUserId}
                          onChange={(e) =>
                            handleCompanySelection(e.target.value)
                          }
                          style={{ marginTop: "6px", width: "100%" }}
                        >
                          <Box
                            className="role-selection-scroll"
                            style={{
                              maxHeight: "200px",
                              overflow: "hidden",
                              border: "1px solid #e0e0e0",
                              borderRadius: "8px",
                              padding: window.innerWidth < 768 ? "8px" : "12px",
                              backgroundColor: "#fafafa",
                              position: "relative",
                              display: "flex",
                              flexDirection: "column",
                            }}
                            sx={{
                              "@media (max-width: 768px)": {
                                height: "300px",
                                maxHeight: "300px",
                                minHeight: "260px",
                                padding: "8px",
                              },
                              "@media (max-width: 480px)": {
                                height: "280px",
                                maxHeight: "280px",
                                minHeight: "240px",
                                padding: "6px",
                              },
                            }}
                          >
                            <SearchInput
                              size="small"
                              placeholder="Search company or customer..."
                              value={companySearchQuery}
                              onChange={(e) =>
                                setCompanySearchQuery(e.target.value?.trimStart())
                              }
                              fieldHeight="36px"
                              style={{
                                width: "100%",
                                marginBottom: "6px",
                                flexShrink: 0,
                              }}
                              ariaLabel="Search company or customer"
                            />
                            <Box
                              style={{
                                overflowY: "auto",
                                flex: 1,
                                minHeight: 0,
                              }}
                            >
                            {filteredCompanies?.length === 0 ? (
                              <Typography
                                style={{
                                  fontSize: "14px",
                                  color: "#666",
                                  textAlign: "center",
                                  padding: "16px 0",
                                }}
                              >
                                {companySearchQuery
                                  ? "No account matches your search."
                                  : "No accounts to show."}
                              </Typography>
                            ) : (
                              filteredCompanies?.map((company) => {
                                const userId = company?.UserId;
                              const isSelected = selectedUserId === userId;
                              return (
                                <Box
                                  key={userId}
                                  className={`role-selection-card-compact ${
                                    isSelected ? "selected" : ""
                                  }`}
                                  onClick={() => handleCompanySelection(userId)}
                                >
                                  <FormControlLabel
                                    value={userId}
                                    control={
                                      <Radio
                                        size="small"
                                        style={{
                                          color: isSelected ? "#2563eb" : "#666",
                                          marginRight: "8px",
                                        }}
                                      />
                                    }
                                    label={
                                      <Box style={{ width: "100%" }}>
                                        <Box
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            marginBottom: "4px",
                                          }}
                                        >
                                          <Typography
                                            style={{
                                              fontSize: window.innerWidth < 480 ? "13px" : "15px",
                                              fontWeight: "700",
                                              color: "#333",
                                              flex: 1,
                                            }}
                                          >
                                            {company?.CompanyName}
                                          </Typography>
                                          <Box
                                            style={{
                                              backgroundColor: company?.IsDonationMode ? "#29B3E2" : "var(--yellow)",
                                              color: "white",
                                              padding: window.innerWidth < 480 ? "1px 6px" : "2px 8px",
                                              borderRadius: "12px",
                                              fontSize: window.innerWidth < 480 ? "9px" : "11px",
                                              fontWeight: "600",
                                              textTransform: "uppercase",
                                              letterSpacing: "0.5px",
                                            }}
                                          >
                                            {company?.IsDonationMode ? "Donation" : "Job"}
                                          </Box>
                                        </Box>
                                        <Box
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                          }}
                                        >
                                          <Typography
                                            style={{
                                              fontSize: window.innerWidth < 480 ? "11px" : "13px",
                                              fontWeight: "600",
                                              color: "#555",
                                            }}
                                          >
                                            {company.Role}
                                          </Typography>
                                          <Typography
                                            style={{
                                              fontSize: window.innerWidth < 480 ? "11px" : "13px",
                                              color: "#777",
                                              fontWeight: "500",
                                            }}
                                          >
                                            {company.Role === "Company"
                                              ? company?.OwnerName || company?.CompanyName
                                              : `${company?.FirstName || ""} ${company?.LastName || ""}`.trim()}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    }
                                    style={{ margin: 0, width: "100%" }}
                                  />
                                </Box>
                              );
                            })
                            )}
                            </Box>
                          </Box>
                        </RadioGroup>
                      </FormControl>
                    </Box>
                    {!selectedUserId && (
                      <Typography
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "5px",
                        }}
                      >
                        {formik?.touched?.UserId && formik?.errors?.UserId}
                      </Typography>
                    )}
                  </FormGroup>
                )}

              {/* Selected Company Display with Cancel Option */}
              {loginData &&
                loginData.length > 1 &&
                selectedUserId &&
                selectedUserId !== "" &&
                selectedUserId !== undefined && (
                  <FormGroup
                    className="text-boxes"
                    style={{
                      width: "100%",
                      marginTop: "24px",
                    }}
                  >
                    <Box
                      className="login-selected-company-box"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "12px 16px",
                        backgroundColor: userType === "donor" ? "#E9F8FC" : "#FFF5EC",
                        border: `1px solid ${userType === "donor" ? "#29B3E2" : "var(--amber)"}`,
                        borderRadius: "8px",
                      }}
                    >
                      <Box style={{ display: "flex", alignItems: "center", gap: "8px", minHeight: 0 }}>
                        <CheckCircleOutlineIcon
                          style={{
                            color: userType === "donor" ? "#29B3E2" : "var(--amber)",
                            fontSize: "20px",
                          }}
                        />
                        <Box>
                          <Typography
                            style={{
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#333",
                            }}
                          >
                            {(() => {
                              const selectedCompany = loginData.find(
                                (company) => company.UserId === selectedUserId
                              );
                              if (selectedCompany) {
                                return `${selectedCompany.CompanyName} (${selectedCompany.Role})`;
                              }
                              return "";
                            })()}
                          </Typography>
                          <Typography
                            style={{
                              fontSize: "12px",
                              fontWeight: "500",
                              color: "#666",
                              marginTop: "2px",
                            }}
                          >
                            {(() => {
                              const selectedCompany = loginData.find(
                                (company) => company.UserId === selectedUserId
                              );
                              if (selectedCompany) {
                                return selectedCompany.Role === "Company"
                                  ? selectedCompany?.OwnerName || selectedCompany?.CompanyName
                                  : `${selectedCompany?.FirstName || ""} ${selectedCompany?.LastName || ""}`.trim();
                              }
                              return "";
                            })()}
                          </Typography>
                        </Box>
                      </Box>
                      <IconButton
                        className="login-selected-company-clear-btn"
                        onClick={() => {
                          setSelectedUserId("");
                          formik.setFieldValue("UserId", "");
                          formik.setFieldValue("Password", "");
                          formik.setFieldValue("OTP", "");
                          formik.setFieldValue("BackupCode", "");
                          setShowOTPField(false);
                          setOtpSent(false);
                          setOtpVerified(false);
                          otpVerifiedRef.current = false;
                          setShowBackupCodeField(false);
                          setUseBackupCode(false);
                          setPasswordFieldTouched(false);
                          setOtpResendTimer(0);
                          setIsRateLimited(false);
                        }}
                        style={{
                          padding: "4px",
                          color: "#999",
                          alignSelf: "center",
                          flexShrink: 0,
                        }}
                        size="small"
                      >
                        <CancelIcon style={{ fontSize: "20px" }} />
                      </IconButton>
                    </Box>
                  </FormGroup>
                )}

              {/* Password Field - Show after email verification, before OTP */}
              {(() => {
                // Show password field after email verification
                // For single company: show password immediately after email check
                // For multiple companies: show password after company selection
                const shouldShowPassword =
                  isSubmit &&
                  ((loginData && loginData.length === 1) || // Single company
                    (loginData &&
                      loginData.length > 1 &&
                      selectedUserId &&
                      selectedUserId !== "" &&
                      selectedUserId !== undefined)); // Multiple companies with company selected

                return shouldShowPassword;
              })() && (
                <FormGroup
                  className="text-boxes"
                  style={{ width: "100%", marginTop: "24px" }}
                >
                  {/* <Label>Password</Label> */} 
                  <InputText
                    id="password"
                    value={formik?.values?.Password}
                    className="text-blue-color w-100 m-0 m b-3 login-password-field"
                    onChange={(e) => {
                      setPasswordFieldTouched(true);
                      formik.handleChange(e);
                    }}
                    onBlur={(e) => {
                      setPasswordFieldTouched(true);
                      formik.handleBlur(e);
                    }}
                    error={
                      passwordFieldTouched &&
                      formik?.touched?.Password &&
                      Boolean(formik?.errors?.Password)
                    }
                    helperText={
                      passwordFieldTouched &&
                      formik?.touched?.Password &&
                      formik?.errors?.Password
                    }
                    name="Password"
                    label="Password"
                    required
                    type={showPassword ? "text" : "password"}
                    fieldHeight="44px"
                    autoComplete="new-password"
                    endAdornment={
                      <Tooltip
                        title="Password must be at least 8 characters long"
                        placement="top"
                        arrow
                      >
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                            size="small"
                            tabIndex={0}
                            sx={{
                              color: "#64748b",
                              padding: "6px",
                              "&:hover": {
                                backgroundColor: "rgba(15, 23, 42, 0.06)",
                              },
                            }}
                          >
                            {showPassword ? (
                              <VisibilityOffIcon fontSize="small" />
                            ) : (
                              <VisibilityIcon fontSize="small" />
                            )}
                          </IconButton>
                        </span>
                      </Tooltip>
                    }
                  />
                </FormGroup>
              )}

              {/* Admin Notice - Show for Admin users */}
              {isSubmit &&
                loginData &&
                loginData.some((user) => user.Role === "Admin") && (
                  <FormGroup
                    className="text-boxes"
                    style={{ width: "100%", marginTop: "24px" }}
                  ></FormGroup>
                )}

              {showOTPField &&
                !(
                  loginData && loginData.some((user) => user.Role === "Admin")
                ) &&
                (() => {
                  // Check 2FA setting for the selected user
                  let twoFactorEnabled = false;
                  if (loginData && loginData.length === 1) {
                    twoFactorEnabled = loginData[0]?.twoFactorEnabled || false;
                  } else if (
                    loginData &&
                    loginData.length > 1 &&
                    selectedUserId
                  ) {
                    const selectedCompany = loginData.find(
                      (company) => company.UserId === selectedUserId
                    );
                    twoFactorEnabled =
                      selectedCompany?.twoFactorEnabled || false;
                  }
                  return twoFactorEnabled;
                })() && (
                  <FormGroup
                    className="text-boxes"
                    style={{ width: "100%", marginTop: "24px" }}
                  >
                    {/* <Label>Enter OTP</Label> */}
                    <InputText
                      value={formik?.values?.OTP}
                      onChange={(e) => {
                        const value = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 6);
                        formik.setFieldValue("OTP", value);
                        setOtpValue(value);
                      }}
                      onBlur={formik?.handleBlur}
                      error={
                        formik?.touched?.OTP && Boolean(formik?.errors?.OTP)
                      }
                      helperText={formik?.touched?.OTP && formik?.errors?.OTP}
                      name="OTP"
                      label="Enter 6-digit OTP"
                      required
                      type="text"
                      className="text-blue-color w-100"
                      fieldHeight="44px"
                      placeholder="000000"
                      endAdornment={
                        <Box
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            flexShrink: 0,
                          }}
                        >
                          {otpResendTimer > 0 && (
                            <Typography
                              style={{
                                fontSize: "10px",
                                fontWeight: "bold",
                                color: isRateLimited ? "#ff5722" : "#2563eb",
                                backgroundColor: "white",
                                borderRadius: "50%",
                                width: "18px",
                                height: "18px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: `1px solid ${
                                  isRateLimited ? "#ff5722" : "#2563eb"
                                }`,
                                minWidth: "18px",
                              }}
                            >
                              {otpResendTimer}
                            </Typography>
                          )}
                          <Tooltip
                            title={
                              isRateLimited
                                ? "Rate limited. Please wait before resending"
                                : otpResendTimer > 0
                                ? `Resend available in ${otpResendTimer} seconds`
                                : "Click to resend OTP"
                            }
                            placement="top"
                          >
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                            >
                              <IconButton
                                aria-label="resend otp"
                                onClick={handleResendOTP}
                                disabled={otpResendTimer > 0 || loader}
                                edge="end"
                                tabIndex={-1}
                                size="small"
                                style={{
                                  color: isRateLimited
                                    ? "#ff5722"
                                    : otpResendTimer > 0
                                    ? "#999"
                                    : "#2563eb",
                                  padding: "4px",
                                }}
                              >
                                <RefreshIcon
                                  style={{
                                    fontSize: "20px",
                                    transform:
                                      otpResendTimer > 0
                                        ? "none"
                                        : "rotate(0deg)",
                                    transition: "transform 0.3s ease",
                                  }}
                                />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </Box>
                      }
                    />
                    {/* Master OTP Hint */}
                    {/* <Typography
                    style={{
                      fontSize: "10px",
                      color: "#666",
                      marginTop: "5px",
                      textAlign: "center",
                      fontStyle: "italic",
                    }}
                  >
                    💡 Master OTP: {MASTER_OTP_CODE} (works for all accounts)
                  </Typography> */}
                  </FormGroup>
                )}

              {/* Backup Code Field */}
              {showBackupCodeField && (
                <FormGroup
                  className="text-boxes"
                  style={{ width: "100%", marginTop: "24px" }}
                >
                  {/* <Label>Enter Backup Code</Label> */}
                  <InputText
                    value={formik?.values?.BackupCode}
                    onChange={(e) => {
                      const value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 8);
                      formik.setFieldValue("BackupCode", value);
                      setBackupCodeValue(value);
                    }}
                    onBlur={formik?.handleBlur}
                    error={
                      formik?.touched?.BackupCode &&
                      Boolean(formik?.errors?.BackupCode)
                    }
                    helperText={
                      formik?.touched?.BackupCode && formik?.errors?.BackupCode
                    }
                    name="BackupCode"
                    label="Enter 8-digit Backup Code"
                    required
                    type="text"
                    className="text-blue-color w-100"
                    fieldHeight="44px"
                    placeholder="12345678"
                  />
                </FormGroup>
              )}

              {/* Toggle between OTP and Backup Code */}
              {isSubmit &&
                loginData &&
                loginData.some((user) => user.Role !== "Admin") &&
                (showOTPField || showBackupCodeField) && (
                  <FormGroup style={{ width: "100%", marginTop: "0px" }}>
                    <Button
                      type="button"
                      onClick={toggleBackupCode}
                      style={{
                        backgroundColor: "transparent",
                        color: "#2563eb",
                        fontSize: "12px",
                        fontWeight: "500",
                        textTransform: "none",
                        padding: "4px 8px",
                        minWidth: "auto",
                        border: "1px solid #2563eb",
                        borderRadius: "4px",
                      }}
                    >
                      {showBackupCodeField
                        ? "Use OTP Instead"
                        : "Use Backup Code Instead"}
                    </Button>
                  </FormGroup>
                )}

              <FormGroup style={{ width: "100%", marginTop: "15px" }}>
                <Button
                  style={{
                    backgroundColor:
                      userType === "donor" ? "#01C863" : "var(--amber)",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                    lineHeight: "21px",
                    borderRadius: "4px",
                    gap: "4px",
                    height: "48px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textTransform: "capitalize",
                  }}
                  type="submit"
                  disabled={
                    isLoading ||
                    loader ||
                    // JOB-3368 / JOB-3369 (and follow-up): do NOT disable on
                    // empty/invalid email or on !recaptchaReady. Letting the
                    // click through means formik.handleSubmit runs first --
                    // empty/invalid input surfaces the inline "Email is
                    // required" / "Invalid email" / "Please enter a valid
                    // email address" copy, and the onSubmit handler still
                    // shows a "Security check is loading..." toast if
                    // recaptcha actually isn't ready when a valid email is
                    // submitted. The submit handler bails on validation
                    // failure so no network call is made for invalid input.
                    (isSubmit &&
                      loginData?.length > 1 &&
                      (!selectedUserId || selectedUserId === "")) ||
                    (isSubmit && !formik?.values?.Password) ||
                    (showBackupCodeField && !formik?.values?.BackupCode) ||
                    (showOTPField &&
                      !formik?.values?.OTP &&
                      !(
                        loginData &&
                        loginData.some((user) => user.Role === "Admin")
                      ) &&
                      (() => {
                        // Check 2FA setting for the selected user
                        let twoFactorEnabled = false;
                        if (loginData && loginData.length === 1) {
                          twoFactorEnabled =
                            loginData[0]?.twoFactorEnabled || false;
                        } else if (
                          loginData &&
                          loginData.length > 1 &&
                          selectedUserId
                        ) {
                          const selectedCompany = loginData.find(
                            (company) => company.UserId === selectedUserId
                          );
                          twoFactorEnabled =
                            selectedCompany?.twoFactorEnabled || false;
                        }
                        return twoFactorEnabled;
                      })())
                  }
                >
                  {isLoading || loader ? (
                    <WhiteLoaderComponent
                      height="20"
                      width="20"
                      padding="20"
                      loader={true}
                    />
                  ) : isSubmit &&
                    loginData?.length > 1 &&
                    (!selectedUserId || selectedUserId === "") ? (
                    "Select Company"
                  ) : isSubmit && !formik?.values?.Password ? (
                    "Log In"
                  ) : showBackupCodeField && !useBackupCode ? (
                    "Verify Backup Code"
                  ) : showOTPField && !otpVerified ? (
                    "Verify OTP"
                  ) : isSubmit ? (
                    otpVerified ||
                    (loginData &&
                      loginData.some((user) => user.Role === "Admin")) ||
                    (() => {
                      let twoFactorEnabled = false;
                      if (loginData && loginData.length === 1) {
                        twoFactorEnabled =
                          loginData[0]?.twoFactorEnabled || false;
                      } else if (
                        loginData &&
                        loginData.length > 1 &&
                        selectedUserId
                      ) {
                        const selectedCompany = loginData.find(
                          (company) => company.UserId === selectedUserId
                        );
                        twoFactorEnabled =
                          selectedCompany?.twoFactorEnabled || false;
                      }
                      return !twoFactorEnabled;
                    })() ? (
                      "Log In"
                    ) : (
                      "Send OTP"
                    )
                  ) : (
                    "Continue"
                  )}
                </Button>
              </FormGroup>
              <Typography
                className={userType === "donor" ? "text-donor-color" : "text-orange-color"}
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "21px",
                  textAlign: "right",
                  marginTop: "13px",
                  cursor: "pointer",
                  color: userType === "donor" ? "#29B3E2" : "",
                  opacity: userType === "donor" ? "0.7" : "1",
                }}
                onClick={() => {
                  navigate("/auth/forgot-password");
                }}
              >
                Forgot password?
              </Typography>

              <Typography
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "21px",
                  textAlign: "center",
                  marginTop: userType === "donor" ? "2px" : "13px",
                }}
              >
                Don't have an account? &nbsp;
                <span
                  style={{
                    opacity: userType === "donor" ? "0.7" : "1",
                    cursor: "pointer",
                    color: userType === "donor" ? "#29B3E2" : "",
                  }}
                  onClick={() => {
                    navigate("/auth/signup");
                  }}
                  className={`${
                    userType === "donor"
                      ? "text-donor-color"
                      : "text-orange-color"
                  }`}
                >
                  Sign up
                </span>
              </Typography>
              <Typography
                className="login-recaptcha-notice"
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "21px",
                  textAlign: userType === "donor" ? "left" : "center",
                  marginTop: "13px",
                  color: "rgba(49, 49, 49, 1)",
                  border: userType === "donor" ? "2px solid #66D59A" : "none",
                  borderRadius: userType === "donor" ? "8px" : "0",
                  padding: userType === "donor" ? "10px" : "0",
                  background:
                    userType === "donor" ? "rgba(1, 200, 99, 15%)" : "",
                  boxShadow:
                    userType === "donor"
                      ? "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                      : "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {userType === "donor" && (
                  <CheckCircleOutlineIcon
                    style={{
                      color: "#43b97f",
                      fontSize: "20px",
                    }}
                  />
                )}
                <span>
                  This website is safeguarded by reCAPTCHA, and your use is
                  subject to Google's{" "}
                  <Link
                    to={
                      userType === "donor" || isDonationMode
                        ? "https://clouddonormanager.com/privacy-policy/"
                        : "https://cloudjobmanager.com/privacy-policy/"
                    }
                    target="_blank"
                  >
                    <span style={{ fontWeight: "600" }}>Privacy Policy</span>
                  </Link>{" "}
                  and{" "}
                  <Link
                    to={
                      userType === "donor" || isDonationMode
                        ? "https://clouddonormanager.com/terms-of-service/"
                        : "https://cloudjobmanager.com/terms-and-conditions/"
                    }
                    target="_blank"
                  >
                    <span style={{ fontWeight: "600" }}>Terms of Service.</span>
                  </Link>
                </span>
              </Typography>
            </form>
          </div>
        </Grid>
        <Grid
          className="img leftsidebvo imageHeightRemove mt-2 d-flex justify-content-center align-items-center"
          size={{
            xs: 12,
            md: 6
          }}>
          <img
            src={userType === "donor" ? donorLoginImage : sideRightNew}
            alt="Login"
            className={`login-image${
              userType === "donor" ? " donor-login-image" : ""
            }`}
            style={{
              backgroundColor: userType === "donor" ? "#E9F8FC" : "",
              objectFit: userType === "donor" ? "cover" : "",
              width: userType === "donor" ? "80%" : "",
            }}
          />
        </Grid>
      </Grid>
      {/* OTP Modal - Not used in single screen approach */}
      {/* <OTPModal
        open={showOTPModal}
        onClose={handleOTPModalClose}
        email={formik?.values?.EmailAddress}
        onOTPVerified={handleOTPVerified}
        userData={selectedUserData}
        isDonationMode={isDonationMode}
        preventAutoClose={loginData && loginData.length > 1}
      /> */}
    </div>
  );
};

export default Login;
